import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, CircularProgress, Divider, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Paper, Select, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore, Search } from '@mui/icons-material';
import Global from '../../../customlib/Global';
import DateRangePicker from '../../../customlib/DateRangePicker';
class FollowUpReportMobile extends Component {
    state = {

     } 

    render() { 
        return (
            <Box>
                <NavbarMobile showBackButton={!this.props.showBackButton ? false : true} title={this.props.title ?? "Follow Up Harian"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    {/* <Filter {...this.props}> */}
                    <h3>Report Performance Tele Data Pending</h3>
                    <Box>
                        <DateRangePicker onDateChanged={this.props.handleDateChanged} />
                    </Box>
                    <Box sx={{mb: "10px", mt: "10px"}}>
                        <Button 
                            disabled={this.props.state.isLoadingReport} 
                            variant='contained' 
                            color='primary' 
                            fullWidth 
                            onClick={() => {this.props.getReportFu()}} className="btn btn-primary" style={{padding: 5}}
                        >Tampilkan</Button>
                    </Box>

                    {
                        this.props.state.isLoadingReport && <LinearProgress />
                    }
                    <Divider />
                    <Paper elevation={0}>
                        {
                            this.props.state.reportFuPerformance?.map((row) => {
                                return (
                                    <Paper elevation={1} sx={{mb: "10px"}}>
                                        <Box sx={{margin: "10px"}}>
                                            <strong>{row.salesName}</strong>
                                        </Box>
                                        <Box sx={{pl: "10px", pr: "10px"}}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={4} textAlign={"left"}>
                                                    FU
                                                    <Box><strong>{row.totalFu}</strong></Box>
                                                </Grid>
                                                <Grid item xs={4} textAlign={"center"}>
                                                    Total Register
                                                    <Box><strong>{row.totalCustRegister}</strong></Box>
                                                </Grid>
                                                <Grid item xs={4} textAlign={"right"}>
                                                    Order
                                                    <Box><strong>{row.totalCustOrder}</strong></Box>
                                                </Grid>
                                                <Grid item xs={4} textAlign={"left"}>
                                                    Pembelian
                                                    <Box><strong>{row.totalOrder}</strong></Box>
                                                </Grid>
                                                <Grid item xs={4} textAlign={"center"}>
                                                    Avg
                                                    <Box><strong>{row.rataRata}</strong></Box>
                                                </Grid>
                                                <Grid item xs={4} textAlign={"right"}>
                                                    Closing
                                                    <Box><strong>{row.closingDatabase}</strong></Box>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Paper>
                                );
                            })
                        }
                        <Box sx={{mt: "10px", mb: "10px"}}>
                            <h3>Report By Hasil FU</h3>
                        </Box>
                        {
                            this.props.state.reportPivotFu?.map((row) => {
                                return (
                                    <Paper elevation={1} sx={{mt: "8px", mb: "8px"}}>
                                        
                                        <Box sx={{margin: "15px"}}>
                                            <strong>{row.salesName}</strong>
                                        </Box>
                                        <Box sx={{pl: "10px", pr: "10px"}}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={3} textAlign={"left"}>
                                                    FU
                                                    <Box><strong>{row.jumlah_fu}</strong></Box>
                                                </Grid>
                                                <Grid item xs={3} textAlign={"center"}>
                                                    Respon
                                                    <Box><strong>{row.respon}</strong></Box>
                                                </Grid>
                                                <Grid item xs={3} textAlign={"center"}>
                                                    Tertarik
                                                    <Box><strong>{row.respon_tertarik}</strong></Box>
                                                </Grid>
                                                <Grid item xs={3} textAlign={"right"}>
                                                    Register
                                                    <Box><strong>{row.register}</strong></Box>
                                                </Grid>
                                                <Grid item xs={3} textAlign={"left"}>
                                                    Order
                                                    <Box><strong>{row.order}</strong></Box>
                                                </Grid>
                                                <Grid item xs={3} textAlign={"center"}>
                                                    Menolak
                                                    <Box><strong>{row.menolak}</strong></Box>
                                                </Grid>
                                                <Grid item xs={3} textAlign={"center"}>
                                                    No Invalid
                                                    <Box><strong>{row.no_invalid}</strong></Box>
                                                </Grid>
                                                <Grid item xs={3} textAlign={"right"}>
                                                    Download
                                                    <Box><strong>{row.download_apps}</strong></Box>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Paper>
                                );
                            })
                        }
                    </Paper>
                    
                    {/* </Filter> */}
                    {/* {
                    this.props.state.listMycustomer?.map((lead, index) => {
                        console.log("FUHARIAN", lead);
                        // return (<></>);
                        return (
                            <Accordion key={`key-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={8}>
                                            <Typography component="span">{lead.fromName}</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"left"} sx={{pr: "5px"}}>
                                            {Array.isArray(lead.fuData) ? lead.fuData.length : 0} FU
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography component="span">{lead.from}</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"left"} sx={{pr: "5px"}}>
                                            {Global.formatDateTimeToStrDate(lead.created_at)}
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Paper elevation={0} sx={{mb: "0px", padding: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>Permasalahan</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {!lead.isEditing && lead.alasanUmum}
                                                {lead.isEditing && (
                                                    <FormControl fullWidth variant="outlined" style={{width: '100%'}} size='small'>
                                                        <InputLabel id="demo-simple-select-outlined-label">Permasalahan</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="permasalahan"
                                                            value={lead.permasalahan === undefined | lead.permasalahan === null ? "" : lead.permasalahan}
                                                            onChange={(event) => this.props.handlePermasalahanChange(event, lead)}
                                                            label="Permasalahan"
                                                        >
                                                            {
                                                            Global.getListPermasalahan().map(
                                                                (permasalahan, index) => {
                                                                return (<MenuItem textAlign={"left"} key={"permasalahan" + index + lead._id} value={permasalahan.permasalahan}>{permasalahan.permasalahan}</MenuItem>);
                                                                } 
                                                            )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>Alasan Umum</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {!lead.isEditing && lead.alasanUmum}
                                                {
                                                    lead.isEditing && (
                                                        <Box>
                                                            <FormControl variant="outlined" style={{width: '100%'}} size='small'>
                                                                <InputLabel id="demo-simple-select-outlined-label">Alasan Umum</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-outlined-label"
                                                                    id="alasanUmum"
                                                                    value={lead.alasanUmum === undefined | lead.alasanUmum === null ? "" : lead.alasanUmum}
                                                                    onChange={(event) => this.props.handleAlasanUmumChange(event, lead)}
                                                                    label="Alasan Umum"
                                                                >
                                                                    {
                                                                    Global.getListAlasanUmum(lead.permasalahan).map(
                                                                        (alasanUmum, index) => {
                                                                        return (<MenuItem key={"alasanUmum" + index + lead._id} value={alasanUmum.name}>{alasanUmum.name}</MenuItem>);
                                                                        } 
                                                                    )
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                            {
                                                                lead.lastFuResultTmp === "Order" ? 
                                                                    (<TextField id="outlined-basic" label="Total Order" variant="outlined" style={{marginTop: 10}} value={lead.totalOrder} onChange={(event) => {this.props.handleTotalOrderChange(event, lead)}} />) : 
                                                                    (<></>)
                                                            }
                                                        </Box>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>Alasan Rinci</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {!lead.isEditing && lead.alasanRinci}
                                                {
                                                    lead.isEditing && (
                                                        <Box>
                                                            <FormControl variant="outlined" style={{width: '100%'}} size='small'>
                                                                <InputLabel id="demo-simple-select-outlined-label">Alasan Rinci</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-outlined-label"
                                                                    id="alasanRInci"
                                                                    value={lead.alasanRinci === undefined | lead.alasanRinci === null ? "" : lead.alasanRinci}
                                                                    onChange={(event) => this.props.handleAlasanRinciChange(event, lead)}
                                                                    label="Alasan Rinci"
                                                                >
                                                                    {
                                                                    Global.getListAlasanRinci(lead.permasalahan, lead.alasanUmum).map(
                                                                        (alasanRinci, index) => {
                                                                        return (<MenuItem key={"alasanRinci" + index + lead._id} value={alasanRinci}>{alasanRinci}</MenuItem>);
                                                                        } 
                                                                    )
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                            {
                                                                lead.lastFuResultTmp === "Order" ? 
                                                                    (<TextField id="outlined-basic" label="Total Order" variant="outlined" style={{marginTop: 10}} value={lead.totalOrder} onChange={(event) => {this.props.handleTotalOrderChange(event, lead)}} />) : 
                                                                    (<></>)
                                                            }
                                                        </Box>
                                                    )
                                                }
                                                
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1} >
                                            <Grid item xs={6}>
                                                <strong>Hasil FU</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {
                                                    lead.isEditing && (
                                                        <Box>
                                                            <FormControl variant="outlined" style={{width: '100%'}} size='small'>
                                                                <InputLabel id="demo-simple-select-outlined-label">Hasil Follow Up</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-outlined-label"
                                                                    id="lastFuResult"
                                                                    value={lead.lastFuResultTmp === undefined | lead.lastFuResultTmp === null ? "" : lead.lastFuResultTmp}
                                                                    onChange={(event) => this.props.handleHasilFuChange(event, lead)}
                                                                    label="Hasil Follow Up"
                                                                >
                                                                    {
                                                                    Global.getListHasilFu().map(
                                                                        (cat) => {
                                                                        return (<MenuItem key={cat} value={cat}>{cat}</MenuItem>);
                                                                        } 
                                                                    )
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                            {
                                                                lead.lastFuResultTmp === "Order" ? 
                                                                    (<TextField id="outlined-basic" label="Total Order" variant="outlined" style={{marginTop: 10}} value={lead.totalOrder} onChange={(event) => {this.props.handleTotalOrderChange(event, lead)}} />) : 
                                                                    (<></>)
                                                            }
                                                        </Box>
                                                    )    
                                                }
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1} sx={{mt: "10px"}}>
                                            <Grid item xs={6}>
                                                {
                                                    !lead.isEditing && (
                                                        <Button onClick={() => this.props.toggleStartEditFu(lead)} fullWidth variant='contained' color='secondary'>
                                                            Input FU
                                                        </Button>
                                                    )
                                                }

                                                {
                                                    lead.isEditing && (
                                                        <Button onClick={() => this.props.saveAnalisa(lead)} fullWidth variant='contained' color='error'>
                                                            Submit
                                                        </Button>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                {
                                                    !lead.isEditing && (
                                                        <Button fullWidth variant='contained' color='error'>Buka Chat</Button>
                                                    )
                                                }

                                                {
                                                    lead.isEditing && (
                                                        <Button onClick={() => this.props.toggleStartEditFu(lead)} fullWidth variant='contained' color='warning'>
                                                            Batal
                                                        </Button>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </AccordionDetails>
                            </Accordion>
                            // <Box elevation={2} sx={{mb: "10px", padding: "10px"}} key={`itemleads-${index}`}>
                            //     <Grid container spacing={1}>
                            //         <Grid item xs={12}>
                            //             <Typography component="span">{lead.fromName}</Typography>
                            //         </Grid>
                            //         <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                            //             {Global.maskPhoneNumber(lead.from)}
                            //         </Grid>
                            //         <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                            //             {Global.formatDateTimeToStrDateTime24(lead.created_at)}
                            //         </Grid>
                            //     </Grid>
                            //     <Divider />
                            // </Box>
                        );
                    })
                } */}
                </Box>
            </Box>
        );
    }
}
 
export default FollowUpReportMobile;